/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, March 2020
 *
 *****************************************************************************/

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Amplify, { Auth } from "aws-amplify";
import * as aws_amplify_react from "aws-amplify-react";
import amplifyCustomUi from "aws-amplify-react-custom-ui";
// Store redirect disabled, see checkMobileOperatingSystem below
// import { androidStoreUrl, appleStoreUrl } from "./AppStoreEndpoints";

require("dotenv").config();
process.env.CI = false;

const REACT_APP_AWS_REGION = process.env.REACT_APP_AWS_REGION
const REACT_APP_AWS_USERPOOL_ID = process.env.REACT_APP_AWS_USERPOOL_ID
const REACT_APP_AWS_USERPOOL_WEBCLIENT_ID = process.env.REACT_APP_AWS_USERPOOL_WEBCLIENT_ID

// Amplify configuration
Amplify.configure({
  Auth: {
    region: REACT_APP_AWS_REGION,
    userPoolId: REACT_APP_AWS_USERPOOL_ID,
    userPoolWebClientId: REACT_APP_AWS_USERPOOL_WEBCLIENT_ID,
    mandatorySignIn: true,
    authenticationFlowType: "CUSTOM_AUTH",
    cookieStorage: {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      path: "/",
      expires: 365,
      secure: true
    }
  },
  Analytics: {
    disabled: true
  }
});
Auth.configure();

/**
 * check OS if opened in mobile and redirect to corresponding app store page
 *
 * Disabled 2026-10-07: the Android and iOS apps are not ready yet, so mobile
 * users must be able to sign in on the web. The redirect also sent mobile
 * users of the web apps (scheduler etc.) to the store whenever they had to
 * sign in again. Uncomment this and the AppStoreEndpoints import to restore.
 */
// const checkMobileOperatingSystem = () => {
//   // native javascript way detect OS
//   let userAgent = navigator.userAgent || navigator.vendor || window.opera;
//
//   // if android redirect to play store
//   if (/android/i.test(userAgent)) {
//     window.open(androidStoreUrl, "_self");
//     return;
//   }
//
//   // if ios redirect to app store
//   if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
//     window.open(appleStoreUrl, "_self");
//     return;
//   }
// };
// checkMobileOperatingSystem();

// Configuration for custom signIn page
amplifyCustomUi.configure(aws_amplify_react);

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
